(() => {
  if (window.__meltivaLearnLoaded) return;
  window.__meltivaLearnLoaded = true;

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function activateFormula(root, key) {
    const tabs = $$('[data-learn-formula-tab]', root);
    const panels = $$('[data-learn-formula-panel]', root);
    tabs.forEach((tab) => {
      const active = tab.dataset.learnFormulaTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
      const active = panel.dataset.learnFormulaPanel === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    const timing = root.querySelector('[data-learn-timing-copy]');
    if (timing) {
      const map = {
        tranquility: 'L-theanine human research includes acute measurement windows ranging from tens of minutes onward. Study timing varies by dose and endpoint.',
        ignite: 'Caffeine was measured at 15 and 45 minutes. Methylliberine research also includes 1, 2 and 3 hour measurements after repeated dosing.',
        steady: 'Ginger motion-challenge studies use their own pre-dose and motion-exposure protocols. Study timing is not a promise of Meltiva onset.',
        biome: 'The zinc L-carnosine crossover study highlighted here used a five-day experimental challenge.',
        curb: 'The saffron study highlighted here followed repeated daily use for eight weeks. Gymnema mint research includes both acute and repeated-use designs.',
        hydrate: 'HYDRATE is not positioned around a research-based onset claim. The formula is discussed as a low-mass film used alongside water.'
      };
      timing.textContent = map[key] || '';
    }
  }

  function initFormulaExplorer(root) {
    if (!root || root.dataset.learnReady === 'true') return;
    root.dataset.learnReady = 'true';
    const tabs = $$('[data-learn-formula-tab]', root);
    if (!tabs.length) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateFormula(root, tab.dataset.learnFormulaTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        activateFormula(root, tabs[next].dataset.learnFormulaTab);
      });
    });

    activateFormula(root, tabs.find((t) => t.classList.contains('is-active'))?.dataset.learnFormulaTab || tabs[0].dataset.learnFormulaTab);
  }

  function activateLab(root, key) {
    $$('[data-learn-lab-tab]', root).forEach((tab) => {
      const active = tab.dataset.learnLabTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    $$('[data-learn-lab-panel]', root).forEach((panel) => {
      const active = panel.dataset.learnLabPanel === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function initLab(root) {
    const tabs = $$('[data-learn-lab-tab]', root);
    if (!tabs.length) return;
    tabs.forEach((tab) => tab.addEventListener('click', () => activateLab(root, tab.dataset.learnLabTab)));
    activateLab(root, tabs.find((t) => t.classList.contains('is-active'))?.dataset.learnLabTab || tabs[0].dataset.learnLabTab);
  }

  function initResearch(root) {
    const filters = $$('[data-learn-research-filter]', root);
    const cards = $$('[data-learn-study]', root);
    if (!filters.length || !cards.length) return;

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.learnResearchFilter;
        filters.forEach((f) => f.classList.toggle('is-active', f === button));
        cards.forEach((card) => {
          const tags = (card.dataset.learnStudy || '').split(' ').filter(Boolean);
          card.hidden = key !== 'all' && !tags.includes(key);
        });
      });
    });
  }

  function initAnchorOffset() {
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute('href')?.slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      const sticky = document.querySelector('sticky-header,.header-wrapper,[data-sticky-header]');
      const offset = Math.max(88, sticky?.getBoundingClientRect().height || 0) + 14;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', `#${id}`);
    });
  }

  function init() {
    $$('[data-learn-formulas]').forEach(initFormulaExplorer);
    $$('[data-learn-lab]').forEach(initLab);
    $$('[data-learn-research]').forEach(initResearch);
    initAnchorOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-learn-formulas]').forEach(initFormulaExplorer);
    if (event.target.matches?.('[data-learn-formulas]')) initFormulaExplorer(event.target);
    if (event.target.matches?.('[data-learn-lab]')) initLab(event.target);
    if (event.target.matches?.('[data-learn-research]')) initResearch(event.target);
  });
})();
